import { useEffect } from 'react';

export default function SEO({ title, description }) {
  const fullTitle = `${title} | Asian Axxon Hospitals`;
  const schema = { '@context': 'https://schema.org', '@type': 'Hospital', name: 'Asian Axxon Hospitals', url: 'https://asian.renovateexperthyd.com', telephone: '+91 76500 00108', address: { '@type': 'PostalAddress', streetAddress: 'Balapur, RR District', addressLocality: 'Hyderabad', postalCode: '500070', addressCountry: 'IN' } };
  useEffect(() => {
    document.title = fullTitle;
    const setMeta = (selector, attribute, value) => {
      let node = document.head.querySelector(selector);
      if (!node) { node = document.createElement('meta'); document.head.appendChild(node); }
      node.setAttribute(attribute, selector.includes('property=') ? selector.match(/property="([^"]+)/)[1] : selector.match(/name="([^"]+)/)[1]);
      node.setAttribute('content', value);
    };
    setMeta('meta[name="description"]', 'name', description);
    setMeta('meta[property="og:title"]', 'property', fullTitle);
    setMeta('meta[property="og:description"]', 'property', description);
    let script = document.head.querySelector('#hospital-schema');
    if (!script) { script = document.createElement('script'); script.id = 'hospital-schema'; script.type = 'application/ld+json'; document.head.appendChild(script); }
    script.textContent = JSON.stringify(schema);
  }, [fullTitle, description]);
  return null;
}
